<template>
  <svg :width="width" :height="height" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 10.5L6 10.5" :stroke="color" stroke-width="2" stroke-linecap="round"/>
    <path d="M17.48 13.4402L20 10.5002L17.48 7.56019" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15 4.30435L15 1L1 0.999999L1 20L15 20L15 16.6957" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default{
  name: 'logoutIcon',
  props: {
    color: {
      type: String,
      required: false,
      default: 'currentColor'
    },
    width: {
      type: [String, Number],
      default: '21'
    },
    height: {
      type: [String, Number],
      default: '21'
    }
  }
}</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/common/icon/LogoutIcon.vue